export default __webpack_public_path__ + "static/media/adomi_sent.5285d0fc.png";